module.exports = __webpack_public_path__ + "media/images/home/home_img4-f8ee68b1275c42fae6e2c7112522600c.jpg";